<template>
  <section class="userAdd">
    <el-dialog
      :title="id ? '编辑' : '添加'"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="60%"
      @close="cancelSubmit"
    >
      <div class="userAdd-content">
        <el-form
          :model="info"
          :rules="rules"
          status-icon
          ref="info"
          label-position="left"
          label-width="80px"
        >
          <el-form-item prop="range" label="时间：">
            <el-date-picker
              v-model="info.range"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="handleChange"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="class_id" label="班级：">
            <el-select
              v-model="info.class_id"
              placeholder="请选择班级"
              multiple
              value-key="id"
              @change="handleChange"
            >
              <el-option
                v-for="item in gradeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="internal_user_id" label="教师：">
            <el-select
              v-model="info.internal_user_id"
              multiple
              placeholder="请选择教师"
              value-key="id"
              @change="handleChange"
            >
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="student_count" label="人数：">
            <el-input-number
              v-model="info.student_count"
              :step="1"
              step-strictly
              :min="0"
            ></el-input-number>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="userAdd-foot">
        <el-button @click="cancelSubmit">取 消</el-button>
        <el-button type="primary" @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import mock from "@/utils/mock";
import api from "@/api/app";
export default {
  name: "comUserAdd",
  components: {},
  props: {
    value: Boolean,
    id: Number,
    roomId: {
      type: Number,
      default: 0,
    },
    childId: {
      type: Number,
      default: 0,
    },
    rules: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  watch: {
    value: {
      handler(val) {
        this.dialogVisible = val;
        if (val) {
          if (this.id) {
            this.initEdit();
          } else {
            this.initAdd();
          }
        }
      },
    },
  },
  computed: {},
  data() {
    return {
      dialogVisible: false,
      mineInfo: mock.mine.course.viewInfo,
      mineInit: mock.mine.course.init,
      userList: null,
      gradeList: null,
      data1: null,
      info: {
        class_id: [],
        internal_user_id: [],
        student_count: 0,
        range: [
          new Date().Format("yyyy-MM-dd HH:mm:ss"),
          new Date().Format("yyyy-MM-dd HH:mm:ss"),
        ],
      },
    };
  },
  methods: {
    async init() {
      this.gradeList = await this.mineInit.data3();
      this.userList = await this.mineInit.data4();
      this.info.func_room_id = this.roomId;
    },
    initAdd() {
      this.init();
      this.info.class_id = [];
      this.info.internal_user_id = [];
      this.info.student_count = 0;
      this.info.range = [
        new Date().Format("yyyy-MM-dd HH:mm:ss"),
        new Date().Format("yyyy-MM-dd HH:mm:ss"),
      ];
    },
    async initEdit() {
      this.init();
      let obj1 = {};
      obj1.room_id = this.roomId;
      let list = await this.mineInit.data1(obj1);
      this.data1 = list.find((n) => n.id == this.id);
      let obj2 = this.data1.child.find((x) => x.id == this.childId);
      this.info.id = obj2.id;
      this.info.class_id = obj2.class_id_arr;
      this.info.internal_user_id = obj2.teacher_id_arr;
      this.info.student_count = obj2.student_count;
      this.info.range = obj2.time_range;
    },
    handleChange(v) {
      this.$forceUpdate();
    },
    handleSubmit() {
      let data1 = new Date(this.info.range[0]).getTime();
      let data2 = new Date().getTime();
      if (data1 < data2) {
        this.$message.error("排课开始时间不能早于当前时间");
      } else {
        if (this.id) {
          api.mine.update.course(this.info).then((res) => {
            this.$message.success("编辑成功");
          });
        } else {
          api.mine.create.course(this.info).then((res) => {
            this.$message.success("添加成功");
          });
        }
        this.cancelSubmit();
      }
    },
    cancelSubmit: function () {
      this.dialogVisible = false;
      this.$emit("input", false);
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped >
.userAdd {
  &-content {
    height: 100%;
    text-align: center;
  }
}
</style>
<style scoped lang="scss">
.userAdd-content /deep/ .el-select {
  width: 100%;
}
.userAdd-content /deep/ .el-input-number {
  width: 100%;
}
.userAdd-content /deep/ .el-input__inner {
  text-align: center;
  width: 100%;
}
</style>
